var render = function render(){var _vm=this,_c=_vm._self._c;return _c('audit-log',{attrs:{"is-loading":_vm.isLoading,"title":`${_vm.notification.name} Notification Audit Log`,"entries":_vm.auditLog,"get-changes":_vm.getChanges},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }